export default "__VITE_ASSET__BmxdV4X6__"